import { render, staticRenderFns } from "./DefaultWizard.vue?vue&type=template&id=78a1caee&scoped=true"
import script from "./DefaultWizard.vue?vue&type=script&lang=js"
export * from "./DefaultWizard.vue?vue&type=script&lang=js"
import style0 from "./DefaultWizard.vue?vue&type=style&index=0&id=78a1caee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1caee",
  null
  
)

export default component.exports